import { defineNamespace, type TFunction } from "@nxt-shared/i18n"
import en from "./locales/en.json" with { type: "json" }

export const me = defineNamespace("me", en, {
  de: () => import("./locales/de.json"),
})

/** user-ui's `t`, for plain modules that produce copy (they take it as a parameter). */
export type T = TFunction<typeof en>
